<template>
  <div class="form-field-container" :class="[classes.fieldContainer]">
    <div class="flex items-center">
      <div
        class="form-field"
        :class="[error && 'error', disabled && 'border border-ricoma-gray-200', classes.field]"
      >
        <input
          :type="inputType"
          :placeholder="placeholder"
          :value="inputValue"
          :id="fieldId"
          class="form-input"
          :class="[leftIcon && 'left', rightIcon && 'right', disabled && 'text-ricoma-gray-600']"
          @keypress="handleKeypress"
          @input="handleInput"
          :disabled="disabled"
        />
        <label
          v-if="!labelOnTheSide"
          :for="fieldId"
          class="form-label-top"
          :class="[disabled && 'text-ricoma-gray-600']"
        >
          {{ label }}
        </label>

        <!-- use slots to add icons to input field -->
        <span v-if="leftIcon" class="form-field-icon left"><slot name="left"></slot></span>
        <span v-if="rightIcon" class="form-field-icon right"><slot name="right"></slot></span>
      </div>
      <!-- show label when positioned to the sides -->
      <label v-if="labelOnTheSide" for="input-field" :class="[labelPositionClass]">
        {{ label }}
      </label>
    </div>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

import { onlyDigitsEvent } from '@/utils';

export default {
  name: 'VFormInput',
  data() {
    return {
      inputValue: '',
    };
  },
  props: {
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    onlyDigits: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: {
      type: String,
      required: false,
    },
    inputType: {
      type: String,
      required: false,
      default: 'text',
    },
    initialValue: {
      type: [String, Number],
      required: false,
      default: '',
    },
    classes: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    reset: {
      type: Boolean,
      required: false,
      default: false,
    },
    resetValue: {
      type: [String, Number],
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'top',
    },
    leftIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    rightIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    formatValue: {
      type: Function,
      required: false,
      default: v => v,
    },
  },
  watch: {
    inputValue(val) {
      this.$emit('update', val);
    },
    initialValue(val) {
      this.inputValue = this.formatValue(val);
    },
    reset(val) {
      val && (this.inputValue = '');
    },
  },
  computed: {
    labelOnTheSide() {
      const re = /(right|left)/gi;
      return re.test(this.labelPosition);
    },
    fieldId() {
      return uuidv4();
    },
    labelPositionClass() {
      switch (this.labelPosition) {
        case 'left':
          return 'form-label-left';
        case 'right':
          return 'form-label-right';
        case 'bottom':
          return 'form-label-bottom';
        default:
          return 'form-label-top';
      }
    },
  },
  methods: {
    handleKeypress(event) {
      return this.onlyDigits ? onlyDigitsEvent(event) : event;
    },
    handleInput(event) {
      const value = event.target.value;
      this.inputValue = this.formatValue(value);
    },
  },
  mounted() {
    // ensure that input values is always updated with the initial value
    this.inputValue = this.initialValue;
  },
};
</script>
